/** Use it instead of .includes method for IE support */
export function arrayIncludes(array, itemOrItems) {
  if (Array.isArray(itemOrItems)) {
    return itemOrItems.every(function (item) {
      return array.indexOf(item) !== -1;
    });
  }

  return array.indexOf(itemOrItems) !== -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/pickers/esm/_helpers/utils.js
// module id = 209
// module chunks = 0